import { useState } from 'react';
import { useNavigate } from 'react-router';
import { api } from '../api/client';
import { useSession } from '../auth/session';
import { Field, FormError, useSubmit } from '../components/Field';
import { AuthCard } from '../components/Layout';

/** First run: creates the owner with the bootstrap secret from the server's .env. */
export function SetupPage() {
  const { signedIn } = useSession();
  const navigate = useNavigate();
  const [bootstrapSecret, setSecret] = useState('');
  const [username, setUsername] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const form = useSubmit(() => api.setup({ bootstrapSecret, username, displayName, password }), ({ user }) => {
    signedIn(user);
    void navigate('/', { replace: true });
  });
  const errors = form.fieldErrors;
  return (
    <AuthCard title="Set up Couch">
      <p className="muted">Create the owner account. This works once.</p>
      <form onSubmit={form.submit} noValidate>
        <Field label="Setup secret" name="bootstrapSecret" type="password" value={bootstrapSecret} onChange={setSecret} autoComplete="off"
          error={errors.bootstrapSecret} hint={<>The value of <code>COUCH_OWNER_BOOTSTRAP_SECRET</code> in the server&apos;s <code>.env</code>.</>} />
        <Field label="Username" name="username" value={username} onChange={setUsername} autoComplete="username" error={errors.username} />
        <Field label="Display name" name="displayName" value={displayName} onChange={setDisplayName} autoComplete="name" error={errors.displayName} />
        <Field label="Password" name="password" type="password" value={password} onChange={setPassword} autoComplete="new-password" error={errors.password} hint="At least 10 characters." />
        <FormError message={form.formError} />
        <button type="submit" disabled={form.pending}>Create owner account</button>
      </form>
    </AuthCard>
  );
}
